// extracted by mini-css-extract-plugin
export default {"container":"MoveElementForm_container__cWINR","smallSelect":"MoveElementForm_smallSelect__hHkaU","input":"MoveElementForm_input__+vDPR","select":"MoveElementForm_select__Wd5ET"};